import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

export const getCohortCondition = dbTableCampaign.getCohortCondition;
export const getCohortedMeasureExpr = dbTableCampaign.getCohortedMeasureExpr;
